module.exports = __webpack_public_path__ + "img/level_14_stellar.7c9cfef2.svg";